"use client";

import { SessionProvider } from "next-auth/react";

/**
 * @param {{ children: import("react").ReactNode, session?: import("next-auth").Session | null }} props
 */
export default function ClientSessionProvider({ children, session }) {
  return (
    <SessionProvider session={session} refetchInterval={60 * 10}>
      {children}
    </SessionProvider>
  );
}
